/**
 * /app/distributions — tenant-wide entry into distributions.
 *
 * Replaced the legacy fixture redirect (hardcoded 'vandermerwe-family-trust').
 * Uses the shared TrustScopedLanding component which surfaces real trust
 * data: empty state if 0 trusts, fast-path redirect if 1, picker if 2+.
 *
 * Per-trust create lives on the trust's distributions tab
 * (/app/trusts/$id/distributions, "New distribution" modal).
 */

import { createFileRoute } from '@tanstack/react-router';
import { TrustScopedLanding } from '../../components/screens/trust-scoped-landing';

export const Route = createFileRoute('/app/distributions')({
  component: () => (
    <TrustScopedLanding
      suffix="distributions"
      eyebrow="Distributions"
      title="Distributions"
      emptyHelp="You don't have any trusts under your administration yet. Distributions appear here once you onboard a trust deed and at least one trustee resolution has been signed."
    />
  ),
});
